// extracted by mini-css-extract-plugin
export default {"item":"MenuDesktopItem_item__7FQNK"};